import HeadingComponent from "../UserInterface/HeadingComponent";
import Description from "../UserInterface/Description";

const Vision = () => {
  return (
    <div className="vision-wrapper">
      <HeadingComponent headingText="Visi" margin="16px" />
      <Description
        mobileWidth="100%"
        maxWidthMobile="400px"
        margin="16px"
        width="710px"
        font="Roboto"
        text={`Kami ada untuk menghadirkan produk dan layanan keuangan yang dapat membantu <span style="color:#E11931;font-weight:bold">menciptakan berbagai kesempatan bagi masyarakat dalam meningkatkan kehidupan mereka</span>. Kami berkomitmen menyediakan layanan keuangan yang <span style="color:#E11931;font-weight:bold">bertanggung jawab</span> dan <span style="color:#E11931;font-weight:bold">dapat dipercaya</span>, di mana pelanggan dan mitra bisnis dapat mengakses layanan kami melalui saluran pilihan mereka.`}
      ></Description>
      <style jsx>
        {`
          .vision-wrapper {
            padding: 16px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .vision-item-wrapper {
            display: flex;
            max-width: 940px;
          }
          .item {
            max-width: 220px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 16px;
          }
          @media only screen and (max-width: 600px) {
            .vision-item-wrapper {
              width: 100vw;
              overflow: auto;
            }
            .item {
              width: 300px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Vision;
